import { useQuery } from "@apollo/client"
import { GET_MY_ORG_MEMBERS } from "../graphql/queries/getMyOrganizationMembers"

export const useMyOrgMembers = () => {
  const { data, error, loading, refetch } = useQuery(GET_MY_ORG_MEMBERS, {})
  return {
    myOrganizationMembers: data?.myOrganization,
    error,
    loading,
    refetch,
  }
}
